import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import AlchemyToday from '@/components/ChartTypes/AlchemyToday'
import { Typography, Paper } from 'material-ui'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { graphql } from 'react-apollo'
import { READ_DATASETNAMEDESID } from '@/graphql/queries/dataset'
import { GC_USER_ID } from '@/constants'
import * as moment from 'moment'

const styles = theme => ({
  comingsoon: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: '60%',
    padding: window.innerWidth * 0.2,
    textAlign: 'center',
    left: 0
  },
  paperCalendarView: {
    margin: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #eeeeee',
    color: 'grey'
  }
})

@withApollo
@inject('resultUserTimeline')
@observer
@graphql(READ_DATASETNAMEDESID, {
  name: 'readAllDefaultTables',
  options: ({ match }) => ({
    variables: {
      dataName: 'default',
      userId: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
@withStyles(styles)
export default class TodayTrack extends Component {
  constructor(props) {
    super(props)
    this.state = {
      date: moment().format('l')
    }
  }

  render() {
    const { classes } = this.props

    //get all default tables
    if (this.props.readAllDefaultTables.loading) {
      return <div>Loading tracker data ... </div>
    }

    if (
      this.props.readAllDefaultTables &&
      this.props.readAllDefaultTables.error
    ) {
      return <div>Error: readAllDefaultTables</div>
    }

    // refresh store data just in case
    if (this.props.readAllDefaultTables.allDataSets.length > 0) {
      this.props.resultUserTimeline.data = []
    }

    this.props.resultUserTimeline.rawData = this.props.readAllDefaultTables.allDataSets.filter(
      e =>
        e.name === 'defaultReading' ||
        e.name === 'defaultSleeping' ||
        e.name === 'defaultBodyWeight' ||
        e.name === 'defaultProjects'
    )

    this.props.resultUserTimeline.rawData.forEach(e => {
      if (e.name === 'defaultReading' && e.dataPoints) {
        var data = JSON.parse(e.dataPoints)
        if (data.length > 0) {
          data.forEach(t => {
            t['trackerId'] = 2
            t['trackerName'] = 'reading'
            this.props.resultUserTimeline.data.push(t)
          })
        }
      } else if (e.name === 'defaultSleeping' && e.dataPoints) {
        data = JSON.parse(e.dataPoints)
        if (data.length > 0) {
          data.forEach(t => {
            t['trackerId'] = 5
            t['trackerName'] = 'sleep'
            this.props.resultUserTimeline.data.push(t)
          })
        }
      } else if (e.name === 'defaultBodyWeight' && e.dataPoints) {
        data = JSON.parse(e.dataPoints)
        if (data.length > 0) {
          data.forEach(t => {
            t['trackerId'] = 1
            t['trackerName'] = 'body weight'
            this.props.resultUserTimeline.data.push(t)
          })
        }
      } else if (e.name === 'defaultProjects' && e.dataPoints) {
        data = JSON.parse(e.dataPoints)
        if (data.length > 0) {
          data.forEach(t => {
            t['trackerId'] = 7
            t['trackerName'] = 'project'
            this.props.resultUserTimeline.data.push(t)
          })
        }
      }
    })

    return (
      <div>
        <div>
          <Paper className={classes.paperCalendarView}>
            <AlchemyToday
              data={this.props.resultUserTimeline.data}
              width={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24
                  : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 3
                  ? window.innerWidth * 3 * 0.76
                  : 480 * 2
              }
              type={'sleepTracker'}
              goal={''}
              action={(d, t) =>
                t === 'add' ? this.handleOpenAdd(d) : this.handleOpenView(d)
              }
            />
          </Paper>
        </div>
        <div id="comingsoon" className={classes.comingsoon}>
          <img
            alt=""
            style={{ width: window.innerWidth * 0.6 }}
            src={this.props.img}
          />
          <Typography variant="display1">
            <br /> Coming Soon <br />
            <br />
          </Typography>
          <Typography variant="subheading">
            {this.props.track}
            <br />
          </Typography>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/today.js